export const CSV_HEADERS = {
    ITEM: 'item',
    TAG: 'Tag',
    EN_VALUE: 'EN',
    FR_VALUE: 'FR',
    DE_VALUE: 'DE',
    IT_VALUE: 'IT',
    ZH_VALUE: 'ZH',
    ES_VALUE: 'ES',
    PT_VALUE: 'PT',
    VI_VALUE: 'VI',
    TR_VALUE: 'TR',
    DESCRIPTION: 'Description',
};
